export const getStandaloneJoinPath = (gameType?: string | null) => {
  if (gameType === 'flipCardGame') return '/join-bandido';
  if (gameType === 'doubleDown') return '/join-rolla';
  return '/join-zooma';
};

export const getStandaloneGamePath = (gameType: string, gameRoomId: string | number) => {
  if (gameType === 'flipCardGame') return `/flip-card-game/game/${gameRoomId}`;
  if (gameType === 'doubleDown') return `/double-down/game/${gameRoomId}`;
  return `/quiz-marathon/game/${gameRoomId}`;
};

export const getHopGamePath = (gameType: string, gameRoomId: string | number) => {
  if (gameType === 'flipCardGame') return `/flip-card-game/hop/${gameRoomId}`;
  if (gameType === 'doubleDown') return `/double-down/hop/${gameRoomId}`;
  return `/quiz-marathon/hop/${gameRoomId}`;
};

export const getStoredStandaloneJoinPath = () => {
  const standaloneDataStr = localStorage.getItem('standaloneGameData');
  if (standaloneDataStr) {
    try {
      const standaloneData = JSON.parse(standaloneDataStr);
      if (standaloneData?.gameType) return getStandaloneJoinPath(standaloneData.gameType);
    } catch {
      // Fall back to currentGameType below.
    }
  }

  return getStandaloneJoinPath(localStorage.getItem('currentGameType'));
};
